import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import Mine from '@/components/Mine.vue'
import ReturnBox from '@/components/ReturnBox.vue'
import BindForm from '@/components/BindForm.vue'
import BindResult from '@/components/BindResult.vue'
import Caiji from '@/components/Caiji.vue'
import Bill from '@/components/Bill.vue'
import Xucun from '@/components/Xucun.vue'
import Daizhifu from '@/components/Daizhifu.vue'
import Card from '@/components/Card.vue'
import Result    from '@/components/Result.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
     { path: '/',  name: 'Home',component: Home  },
    { path: '/login', redirect: '/login' },
    { path: '/login', name: 'Login', component: Login },
    { path: '/bill', name: 'Bill', component: Bill },
    { path: '/caiji', name: 'Caiji', component: Caiji },
    { path: '/mine', name: 'Mine', component: Mine },
    { path: '/return', name: 'ReturnBox', component: ReturnBox },
    { path: '/xucun', name: 'Xucun', component: Xucun },
    { path: '/bind', name: 'BindForm', component: BindForm },
    { path: '/bind-result', name: 'BindResult', component: BindResult },
    { path: '/daizhifu', name: 'Daizhifu', component: Daizhifu },
    { path: '/card', name: 'Card', component: Card },
    { path: '/result', name: 'Result', component: Result },
  ]
})
